<!--
~ Status indicator template
~ <p>
~
~ @author lachezar.parvin
~ @author Gallagher Bassett IT
~ @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
~
-->

@if (pageIndex > 0) {
  <div>
    <svg xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42">
      <circle cx="21"
        cy="21"
        r="17"
            [attr.fill]="isCurrentPage ? 'var(--primary)' : (requiredCompleted && requiredCount > 0) || completionIndex == 1 ?
            'var(--success-completed-color)' :
            (!requiredCompleted && !isSummaryPage) ? 'var(--required-entry)' : 'var(--white)'"
        stroke="var(--section-title-background)"
        stroke-width="2"/>
      <defs>
        <path id="{{ id }}"
          [attr.stroke-dasharray]="isCurrentPage ? ratio : completionIndex * ratio + ', ' + ratio"
            d="M20 1
          a 17 17 0 0 1 0 34
          a 17 17 0 0 1 0 -34"
          />
      </defs>
      <g fill="none"
        fill-rule="evenodd"
        transform="translate(1 3)">
        <use [attr.stroke]="isCurrentPage ? 'var(--section-title-background)' : 'var(--gb-secondary-blue)'"
          stroke-width="6"
          [attr.xlink:href]="'#'+id"/>
        <use stroke="var(--white)"
          stroke-width="3"
          [attr.xlink:href]="'#'+id"/>
        @if (((requiredCompleted && requiredCount > 0) || completionIndex == 1) && !isCurrentPage) {
          <path
            fill="var(--white)"
            d="M18 22.554l1.055-1.467 5.57-7.743.058-.08c.307-.393.811-.469 1.2-.181.387.287.478.79.192 1.195-.486.687-.98 1.368-1.47 2.051l-5.737 7.989c-.203.284-.45.483-.823.467-.283-.013-.498-.152-.682-.358-1.085-1.217-2.17-2.432-3.256-3.646-.482-.538-.965-1.074-1.442-1.615-.252-.284-.312-.612-.15-.96.153-.323.427-.478.782-.478.276 0 .49.139.67.34.565.632 1.131 1.262 1.7 1.89l2.334 2.596"/>
        }
        @if (!isSummaryPage && !requiredCompleted && !isCurrentPage) {
          <g>
            <text fill="var(--white)"
              x="16"
              y="26"
              font-size="24px"
              font-weight="600">!
            </text>
            <circle cx="20"
              cy="17.7"
              r="13"
              stroke="var(--white)"
              stroke-width="2"/>
          </g>
        }
      </g>
    </svg>
  </div>
}
